var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuActivate2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.25,
    stroke: "#4E3E91",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5004 4.63833C13.7193 5.20672 14.7082 6.17344 15.3041 7.37915C15.9 8.58486 16.0674 9.95762 15.7786 11.2712C15.4898 12.5847 14.762 13.7607 13.7154 14.6053C12.6687 15.4498 11.3655 15.9126 10.0206 15.9173C8.67565 15.922 7.36926 15.4683 6.3167 14.6311C5.26415 13.7938 4.52825 12.623 4.23028 11.3115C3.93232 9.99997 4.09007 8.62608 4.67754 7.41624C5.26501 6.20639 6.24713 5.2328 7.46206 4.65592",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33398V3.88954V9.58398",
    stroke: "#4E3E91",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuActivate2);
export default __webpack_public_path__ + "static/media/menu-activate2.527bbf0e1b629d7a64d8d96482395153.svg";
export { ForwardRef as ReactComponent };